module.exports = __webpack_public_path__ + "static/media/welcome-activity.48d001f8.png";